import React from 'react'
import { Hero,About,Services,Testimonial,Contact,Footer } from '../components'
import Partners from '../components/Partners'
import Meta from '../components/common/Meta'
import Projects from '../components/Projects'
import VideoSection from '../components/VideoSection'

function Home() {
  return (
    <div>
      <Meta
        title="Home | Edges Design Group"
        description="Edges Design Group is an architecture and engineering firm offering architectural design, engineering consulting, construction, and sustainable building solutions across Rwanda and East Africa."
        keywords="
        Edges Design Group, Edges Design Group Rwanda, Edges Design & Engineering,
        Architecture & Engineering Rwanda,
        Architecture and Engineering Rwanda, Design consultants in Rwanda,
        African architecture firm, African architecture & engineering firm,
        Rwanda-based design consultants, East Africa construction experts,
        Global design standards – local expertise,
        Cabinet d’architecture et d’ingénierie au Rwanda,
        Bureau d’ingénierie en Afrique,
        Edges Design Group mu Rwanda,
        Abubatsi n’abashushanya inyubako mu Rwanda,
        Impuguke mu kubaka no gushushanya"
      />
      <Hero/>
      <About/>
      <Services/>
      <Testimonial/>
      <Projects/>
      <Contact/>
      <VideoSection/>
      <Partners/>
      <Footer/>
    </div>
  )
}

export default Home
